
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      playerInfo: null,
      playerStats: null,
    };
  },
  computed: {
    currentSeason () {
      return this.getDefault(`season`);
    },
    currentTeam () {
      return this.getDefault(`team`);
    },
    currentSeasonYears () {
      if (this.defaultCalendarPeriod?.displayName) {
        return this.defaultCalendarPeriod.displayName.replace(`Season `, ``);
      }
      return null;
    },
    playerHasStats () {
      if (this.playerStats?.entity_stats) {
        return this.playerStats.entity_stats.mins_played?.value > 0;
      }
      return false;
    },
    statTypes () {
      if (this.playerInfo) {
        const position = this.playerInfo.position;
        const stats = this.siteSettings.featured_player_stats.find(stat => stat.position === position);
        if (stats) {
          return stats.stats.playerstattype.map(stat => stat.displayName);
        }

        const defaultStats = this.siteSettings.featured_player_stats.find(stat => stat.position === `Default`);
        return defaultStats.stats.playerstattype.map(stat => stat.displayName);
      }
      return null;
    },
    sortedStats () {
      // Sort the stats by the order chosen in WP
      const stats = [];
      if (this.playerStats?.entity_stats) {
        for (const stat of this.statTypes) {
          stats.push(this.playerStats.entity_stats[stat]);
        }
      }
      return stats;
    },
    competition () {
      if (this.playerInfo) {
        return this.playerInfo?.squad?.season?.competition;
      }
      return null;
    },
  },
  mounted () {
    this.getPlayer();
  },
  methods: {
    async getPlayer () {
      const params = {
        include: `squad.season.competition,player.images`,
        filter: {
          'squad.seasonId': this.currentSeason.id,
          'playerId': this.id,
        },
        paginate: 1,
      };
      const request = await this.$getStats(`/playerSquad`, params);
      if (request !== null) {
        this.playerInfo = request.data.length ? request.data[0] : null;
        if (this.playerInfo) {
          this.getPlayerStats();
        }
      }
    },
    async getPlayerStats () {
      const params = {
        stat_types: this.statTypes.join(`||`),
      };
      const endpoint = `stats/custom/season/${this.currentSeason.id}/player/${this.id}/team/${this.currentTeam.id}`;

      const request = await this.$getStats(endpoint, params);
      if (request !== null) {
        this.playerStats = request;
      }
    },
  },
};
